import { createI18n } from 'vue-i18n'
import ko from './locales/ko'
import en from './locales/en'
import ja from './locales/ja'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'ko',
  fallbackLocale: 'ko',
  messages: {
    ko,
    en,
    ja
  }
})

export default i18n
